const messages = {
  title: "Accueil",
  welcomeMessage:
    'Bienvenue sur BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Accueil",
  search: "Recherche",
  sortBy: "Trier par",
  seeMore: "Voir plus",
  bankstatement: {
    yourScore: "Votre nombre actuel de points marketing:",
    lastUpdate: "Dernière mise à jour:",
    link: "Aperçu du solde de points",
  },
  shop: {
    bestSold: "Best-sellers",
    seasonal: "Tendance saison",
    affordable: "À portée de points",
    forPoints: "pour {points} points",
    reachedPoints: "Score requis atteint",
    cartRemainPoints: "Points restants",
    remainingPoints: "{points} Points restants",
    noProducts: "Les critères de recherche n'ont donné aucun résultat",
    variant: "Variantes au choix",
  },
  showAllProducts: "Vers la boutique des primes",
  shopCommingSoon:
    "Récompenser votre engagement, <div>c'est ce qui compte vraiment.</div><div class='font-25'>Votre catalogue cadeaux bientôt disponible.</div>",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>sera bientôt à nouveau disponible.</div>",
  profile: {
      welcome: "Bienvenue sur",
      completeProfile: "Compléter le profil personnel et en plus",
      completeProfileBold: "Assurer 200 points.",
      link: "Afficher le profil",
      fullCompleteProfile: "Votre profil personnel est complet !",
    },
};

export default {
  messages,
};
